module.exports = __webpack_public_path__ + "static/screens-458e64d78c379f7f2f9a6ac7c7424265.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/screens.png
// module id = 2624
// module chunks = 168707334958949